"use client";

import { useTranslations } from "next-intl";
import { brandConfig } from "@/config/brand";

/** Client component for copyright text (needs current year) */
export function CopyrightText() {
	const t = useTranslations("footer");
	const year = new Date().getFullYear();
	return (
		<>
			{t("copyright", {
				year,
				company: brandConfig.copyrightHolder,
				allRightsReserved: t("allRightsReserved"),
			})}
		</>
	);
}
